import {
  PlanningMeasurementRequest,
  PlanningRequestWafer,
  RawPlanningRequest,
  RawPlanningRequestWafer,
} from "@/types/planning";

const mapRequestWafer = (wf: RawPlanningRequestWafer): PlanningRequestWafer => ({
  _id: wf.id,
  id: wf.wafer_id,
  name: wf.wafer.name,
  chipPos: wf.chip_pos_id,
  chipPosName: wf.chip_pos.name,
  dieCount: wf.total_dies,
  estimatedTime: wf.estimated_time / 60,
  stackShort: wf.stack_short,
  status: wf.status,
  measurementSystemId: wf.measurement_system_id,
  measurementSystem: wf.measurement_system,
  priority: wf.priority,
  estFinishTime: wf.est_finish_time,
  estStartTime: wf.est_start_time,
  startedAt: wf.started_at,
  completedAt: wf.completed_at,
});

export const mapRawToPlanningRequest = (raw: RawPlanningRequest): PlanningMeasurementRequest => {
  return {
    createdAt: new Date(raw.created_at),
    id: raw.id,
    mask: raw.mask,
    createdBy: raw.created_by,
    name: raw.name,
    status: raw.status,
    priority: raw.priority,
    project: raw.project,
    imecLotId: raw.imec_lot_id,
    physicalLocation: raw.physical_location,
    testLabel: {
      id: raw.test_label.id,
      name: raw.test_label.name,
      measurementCapability: raw.test_label.measurement_capability,
    },
    waferRequests: raw.wafer_requests.map(mapRequestWafer),
    waferProgress: raw.wafer_progress,
  };
};
